import { render, staticRenderFns } from "./wordsCreate.vue?vue&type=template&id=7e77cd13"
import script from "./wordsCreate.vue?vue&type=script&lang=js"
export * from "./wordsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports